import { Link } from 'react-router-dom';
import { FaEnvelope, FaMapMarkerAlt, FaPhoneAlt } from 'react-icons/fa';
import {
  ADDRESS_LINE1,
  ADDRESS_LINE2,
  COMPANY_EMAIL,
  COMPANY_NAME,
  SITE_NAME,
} from '../../constants/site';
import {
  COPYRIGHT_END,
  CRUISE_FOOTER_COMPANY,
  CRUISE_FOOTER_META,
  CRUISE_FOOTER_POLICIES,
  CRUISE_FOOTER_SUPPORT,
  CRUISE_LEGAL_DISCLAIMER,
} from '../../constants/cruiseLegal';
import { CRUISE_PHONE_DISPLAY, CRUISE_PHONE_TEL } from '../../constants/contact';
import './CruiseFooter.css';

const FOOTER_NAV = [
  { hash: '#home', label: 'Search' },
  { hash: '#regions', label: 'Regions' },
  { hash: '#deals', label: 'Deals' },
  { hash: '#enquiry', label: 'Contact' },
];

function FooterLink({ href, label }) {
  const isExternal = href.startsWith('http');
  if (isExternal) {
    return (
      <a href={href} target="_blank" rel="noopener noreferrer">
        {label}
      </a>
    );
  }
  if (href.startsWith('#')) {
    return <a href={href}>{label}</a>;
  }
  return <Link to={href}>{label}</Link>;
}

export default function CruiseFooter() {
  return (
    <footer className="cruise-footer">
      <div className="container cruise-footer__main">
        <div className="cruise-footer__brand">
          <p className="cruise-footer__logo">{SITE_NAME}</p>
          <p className="cruise-footer__tagline">Cruise bookings</p>
          <p className="cruise-footer__intro">
            Search Caribbean, Mediterranean, Alaska, and more with 24/7 cruise concierge support.
          </p>
          <p className="cruise-footer__affiliate">{CRUISE_FOOTER_META.affiliate}</p>
        </div>

        <nav className="cruise-footer__nav" aria-label="Cruise page navigation">
          <h4>Explore</h4>
          <ul>
            {FOOTER_NAV.map(({ hash, label }) => (
              <li key={hash}>
                <a href={hash}>{label}</a>
              </li>
            ))}
            <li>
              <Link to="/">Car rentals</Link>
            </li>
          </ul>
        </nav>

        <nav className="cruise-footer__nav" aria-label="Policies">
          <h4>Policies</h4>
          <ul>
            {CRUISE_FOOTER_POLICIES.map(({ href, label }) => (
              <li key={href}>
                <FooterLink href={href} label={label} />
              </li>
            ))}
          </ul>
        </nav>

        <nav className="cruise-footer__nav" aria-label="Company">
          <h4>Company</h4>
          <ul>
            {CRUISE_FOOTER_COMPANY.map(({ href, label }) => (
              <li key={href}>
                <FooterLink href={href} label={label} />
              </li>
            ))}
          </ul>
        </nav>

        <div className="cruise-footer__contact">
          <h4>Support</h4>
          <ul className="cruise-footer__support-links">
            {CRUISE_FOOTER_SUPPORT.map(({ href, label }) => (
              <li key={href}>
                <FooterLink href={href} label={label} />
              </li>
            ))}
          </ul>
          <a href={`tel:${CRUISE_PHONE_TEL}`} className="cruise-footer__cta">
            <FaPhoneAlt aria-hidden />
            <span>
              <small>Call 24/7</small>
              <strong>{CRUISE_PHONE_DISPLAY}</strong>
            </span>
          </a>
          <a href={`mailto:${COMPANY_EMAIL}`} className="cruise-footer__email">
            <FaEnvelope aria-hidden /> {COMPANY_EMAIL}
          </a>
          <p className="cruise-footer__address">
            <FaMapMarkerAlt aria-hidden />
            <span>
              {ADDRESS_LINE1}
              <br />
              {ADDRESS_LINE2}
            </span>
          </p>
        </div>
      </div>

      <div className="container cruise-footer__legal">
        <h4 className="cruise-footer__legal-title">Legal &amp; disclosures</h4>
        <div className="cruise-footer__legal-body">
          <p className="cruise-footer__operator">{CRUISE_FOOTER_META.operator}</p>
          {CRUISE_LEGAL_DISCLAIMER.map((paragraph) => (
            <p key={paragraph.slice(0, 48)}>{paragraph}</p>
          ))}
          <p className="cruise-footer__company-line">
            <strong>{COMPANY_NAME}</strong> · {ADDRESS_LINE1}, {ADDRESS_LINE2}
          </p>
        </div>
      </div>

      <div className="cruise-footer__bar">
        <div className="container cruise-footer__bar-inner">
          <div>
            <p className="cruise-footer__copy">
              &copy; {COPYRIGHT_END} {COMPANY_NAME}. All rights reserved.
            </p>
            <p className="cruise-footer__copy-sub">{CRUISE_FOOTER_META.companyLine}</p>
          </div>
          <div className="cruise-footer__bar-links">
            <a href="https://travelnodex.online/privacy" target="_blank" rel="noopener noreferrer">
              Privacy
            </a>
            <a href="https://travelnodex.online/terms" target="_blank" rel="noopener noreferrer">
              Terms
            </a>
            <a href="#enquiry">Contact</a>
          </div>
        </div>
      </div>
    </footer>
  );
}
